<full-calendar
  #calendar
  [options]="calendarOptions"
  [deepChangeDetection]="true"
></full-calendar>
